export var listItemMap = {
  lg: {
    textSize: 'xl',
    wrapperRadius: 10,
    textPadding: 14
  },
  md: {
    textSize: 'lg',
    wrapperRadius: 8,
    textPadding: 10
  },
  sm: {
    textSize: 'md',
    wrapperRadius: 6,
    textPadding: 6
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL21vbGVjdWxlcy9Db250ZXh0TWVudS91dGlsaXR5LnRzIl0sIm5hbWVzIjpbImxpc3RJdGVtTWFwIiwibGciLCJ0ZXh0U2l6ZSIsIndyYXBwZXJSYWRpdXMiLCJ0ZXh0UGFkZGluZyIsIm1kIiwic20iXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sSUFBTUEsV0FBVyxHQUFHO0FBQ3pCQyxFQUFBQSxFQUFFLEVBQUU7QUFDRkMsSUFBQUEsUUFBUSxFQUFFLElBRFI7QUFFRkMsSUFBQUEsYUFBYSxFQUFFLEVBRmI7QUFHRkMsSUFBQUEsV0FBVyxFQUFFO0FBSFgsR0FEcUI7QUFNekJDLEVBQUFBLEVBQUUsRUFBRTtBQUNGSCxJQUFBQSxRQUFRLEVBQUUsSUFEUjtBQUVGQyxJQUFBQSxhQUFhLEVBQUUsQ0FGYjtBQUdGQyxJQUFBQSxXQUFXLEVBQUU7QUFIWCxHQU5xQjtBQVd6QkUsRUFBQUEsRUFBRSxFQUFFO0FBQ0ZKLElBQUFBLFFBQVEsRUFBRSxJQURSO0FBRUZDLElBQUFBLGFBQWEsRUFBRSxDQUZiO0FBR0ZDLElBQUFBLFdBQVcsRUFBRTtBQUhYO0FBWHFCLENBQXBCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IGxpc3RJdGVtTWFwID0ge1xuICBsZzoge1xuICAgIHRleHRTaXplOiAneGwnLFxuICAgIHdyYXBwZXJSYWRpdXM6IDEwLFxuICAgIHRleHRQYWRkaW5nOiAxNCxcbiAgfSxcbiAgbWQ6IHtcbiAgICB0ZXh0U2l6ZTogJ2xnJyxcbiAgICB3cmFwcGVyUmFkaXVzOiA4LFxuICAgIHRleHRQYWRkaW5nOiAxMCxcbiAgfSxcbiAgc206IHtcbiAgICB0ZXh0U2l6ZTogJ21kJyxcbiAgICB3cmFwcGVyUmFkaXVzOiA2LFxuICAgIHRleHRQYWRkaW5nOiA2LFxuICB9LFxufSBhcyBjb25zdFxuIl19